import { Component, OnInit, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
  selector: "app-transfer-confirmation",
  templateUrl: "./transfer-confirmation.component.html",
  styleUrls: ["./transfer-confirmation.component.css"],
})
export class TransferConfirmationComponent implements OnInit {
  modalResponse = new ModalResponse();
  constructor(
    public dialogRef: MatDialogRef<TransferConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {}

  onClose(): void {
    this.dialogRef.close(this.modalResponse);
  }

  approveDisbursement = () => {
    this.modalResponse.shouldProcess = true;
    this.dialogRef.close(this.modalResponse);
  };
}

export class ModalResponse {
  shouldProcess: boolean;
  saveBeneficary: boolean;
  groupName: string;
}
